import gameState from "slotworks/model/game-state";
import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";

export function getTotalPicks() {
    const childRecords = gameState.getCurrentGame().getRootRecord().children;
    const latestHoldAndSpinRecord = childRecords[childRecords.length - 1] as HoldAndSpinRecord;

    return latestHoldAndSpinRecord ? latestHoldAndSpinRecord.getTotalFreespins() : 3;
}

export function getCurrentPick() {
    const childRecords = gameState.getCurrentGame().getRootRecord().children;
    const latestHoldAndSpinRecord = childRecords[childRecords.length - 1] as HoldAndSpinRecord;

    return latestHoldAndSpinRecord ? latestHoldAndSpinRecord.freespinsSpun : 0;
}
